<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <form class="form" @submit.prevent="sendData">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ title }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                    </svg>
                </span>
              </div>
            </div>
            <div class="modal-body">
                <RequiredText />
                <TagifyInput
                    :parent-id="'#'+id"
                    containerClass="-flex flex-column mb-5 fv-row"
                    type="email"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    size="lg"
                    :is-required="true"
                    :label="$t('devis.to')"
                    labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                    v-model="formData.to"
                    :name="`kt_tagify_to_`+id"
                    :helperText="$t('attributes.tag_input_text')"
                />
                <div class="d-flex flex-column mb-5 fv-row">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span class="required">{{$t('subject')}}</span>
                    </label>
                    <input type="text" class="form-control form-control-solid" v-model="formData.subject" :placeholder="$t('subject')" required />
                </div>
                <CKEditor :id="'devis_message'+id" ktClass="border-top-0 bg-transparent border-0 px-3" :label="$t('content')" :required="true" :content="filterMessage" @text="getDescription"/>
                <div class="border-bottom pb-2 mb-2 mt-5">
                    {{ $t('devis.file_upload') }}
                </div>
              <i class="fas fa-paperclip me-2" style="font-size: 15px; color: var(--bs-primary)"></i> <span class="" style="font-size: 12px"> {{ file_number }} </span>
            </div>
            <div class="modal-footer">
              <Button type="cancel" @click.prevent="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
              <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="crm.devis.send" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
    import { ref, defineProps, onMounted, nextTick, watch, computed } from "vue";
    import Button from "@/components/Button.vue"
    import CKEditor from "@/components/CKEditor.vue"
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText.vue"
    import TagifyInput from "@/components/TagifyInput.vue";

    const emits = defineEmits(['load', 'submit'])
  
    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        title: String,
        content: { Object, default: () => ({
            invoiceId: null,
            body: "",
            subject: '',
            facture: "",
            to: [],
            from: ''
            })
        },
        file_number: String,
        isLoading: Boolean,
        type: String
    })

    const store = useStore()
    const formData = ref(props.content)

    const mailMessage = computed(() => store.getters['mail/getMailMessage'])
    const filterMessage = computed(() => mailMessage.value.filter((message) => message.type.value == props.type)[0]?.content)

    function closeModal(){
        $('#'+props.id).modal('toggle')
    }

    function getDescription(text){
        formData.value.body = text
    }

    function sendData(){
        emits('submit')
    }

    onMounted(() => {
        store.dispatch('mail/loadMailMessage')
    })
</script>
  